// remove duplicates from an array and return the new array
export function dedupe(items) {
  return items.filter(
    (item, index) => items.indexOf(item) === index && Boolean(item),
  );
}

export function sortDate(a, b) {
  const timestampA = Date.parse(a);
  const timestampB = Date.parse(b);

  if (isNaN(timestampA) && isNaN(timestampB)) {
    return 0;
  }

  if (isNaN(timestampA) && !isNaN(timestampB)) {
    // b is greater than A
    return -1;
  }

  if (!isNaN(timestampA) && isNaN(timestampB)) {
    // a is greater than b
    return 1;
  }

  return new Date(a) - new Date(b);
}
